import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Button,
  FormFeedback,
  Alert,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

// Service
import commonService from "../../../services/common.service";
import { useTranslation } from "react-i18next";
import Input from "../../../components/Form/Input";

const CompanyCategoryForm = (props: any) => {
  const {t} = useTranslation();
  let companyCategoryData = props.companyCategoryData;

  const validationSchema = Yup.object().shape({
    category_value: Yup.string()
      .required("Company category field is required.")
      .min(2, "Company category must be at least 2 characters.")
      .max(200, "Company category may not be greater than 200 characters."),
  });

  const handleSubmit = (values: {
    id: string;
    category_id: string;
    category_value: string;
    color_code: string;
  }) => {
    props.onSubmitClick(values);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (companyCategoryData && companyCategoryData.id) || "",
      category_id: (companyCategoryData && companyCategoryData.category_id) || "",
      category_value: (companyCategoryData && companyCategoryData.category_value) || "",
      color_code: (companyCategoryData && companyCategoryData.color_code) || "#000000",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setErrors }) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (!validation.isSubmitting) return;
    if (Object.keys(validation.errors).length > 0) {
      document
        .getElementById(Object.keys(validation.errors)[0])
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      document
        .getElementById(Object.keys(validation.errors)[0])
        ?.focus({ preventScroll: true });
    }
  }, [validation.isSubmitting, validation.errors]);

  return (
    <React.Fragment>
      <Modal
        size="md"
        isOpen={props.show}
        toggle={props.onCloseClick}
        backdrop="static"
        keyboard={false}
        autoFocus={false}
      >
        <div className="modal-header">
          <h5 className="modal-title">{props.modalTitle}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={props.onCloseClick}
            aria-label="Close"
          ></button>
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
          autoComplete="off"
        >
          <ModalBody>
            {props.errorMsg ? 
              <Alert color="danger">
                {props.errorMsg}

                {props.errorData.data ?
                  Object.keys(props.errorData.data).map(key => (
                    <li color="danger" key={key}>{props.errorData.data[key]}</li>
                  )) : null
                }
              </Alert> : null
            }

            <Input
              id="id"
              name="id"
              type="hidden"
              value={validation.values.id || ""}
              onChange={validation.handleChange}
            />
            <Input
              id="category_id"
              name="category_id"
              type="hidden"
              value={validation.values.category_id || ""}
              onChange={validation.handleChange}
            />

            <Row>
              <Col className="col-12">
                <div className="mb-3">
                  <div className="color_palette_main_div">
                    <Input
                      id="category_value"
                      name="category_value"
                      className="form-control"
                      placeholder={t("Company category")}
                      label="Company category"
                      required
                      type="text"
                      value={validation.values.category_value || ""}
                      autoFocus={true}
                      onKeyUp={validation.handleChange}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.category_value &&
                        validation.errors.category_value
                          ? true
                          : false
                      }
                      error={validation.errors.category_value}
                      touched={validation.touched.category_value}
                    />

                    <div className="color_palette_div">
                      <Input
                        id="color_code"
                        name="color_code"
                        type="color"
                        value={validation.values.color_code || ""}
                        className="color_palette"
                        onChange={validation.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              className="btn-block"
              type="submit"
              disabled={props.loading}
            >
              {props.loading ? (
                <span>
                  <i className="fa-solid fa-spinner fa-spin"></i>
                  <span>{t("Please wait...")}</span>
                </span>
              ) : (
                <span>{t("Submit")}</span>
              )}
            </Button>
            <Button
              color="danger"
              className="btn-block"
              type="reset"
              onClick={props.onCloseClick}
              disabled={props.loading}
            >
              {t("Cancel")}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default CompanyCategoryForm;
